import { Card } from "primereact/card";
import { Dialog } from "primereact/dialog";
import { ImageCardProps } from "./types";
import React, { useState } from "react";
import { classNames } from "primereact/utils";

export const VideoCard = ({ videoUrl, icon, title }: ImageCardProps) => {
  const [visible, setVisible] = useState(false);

  const header = (
    <div className="flex align-items-center gap-3">
      {icon && (
        <div className="flex align-items-center justify-content-center border-round bg-primary-100 text-primary w-3rem h-3rem">
          <i className={classNames("pi", icon, "text-xl")} />
        </div>
      )}
      <h2 className="m-0 text-xl font-bold text-900">{title}</h2>
    </div>
  );

  return (
    <>
      <Card
        header={header}
        className="mb-4 shadow-2 border-round-xl mt-1"
        style={{ overflow: "hidden", cursor: videoUrl ? "pointer" : "default" }}
        onClick={() => videoUrl && setVisible(true)}
      >
        {videoUrl ? (
          <video
            src={videoUrl}
            controls
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full flex align-items-center justify-content-center text-color-secondary">
            No Image
          </div>
        )}
      </Card>

      <Dialog
        visible={visible}
        onHide={() => setVisible(false)}
        header={title}
        dismissableMask
        className="max-w-screen-md"
      >
        <video
          src={videoUrl}
          controls
          className="w-full h-full object-contain border-round"
        />
      </Dialog>
    </>
  );
};
